// action - state management
import { LOGIN, LOGOUT, REGISTER, SAVE_COGNITO_USER, LOGIN_COGNITO, SET_ASSOCIATE_SOFTWARE_TOKEN } from './actions';
import { InitialLoginContextProps } from 'types/auth';

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
    type: string;
    payload?: InitialLoginContextProps;
}

const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    isBackendLoggedIn: false,
    isCognitoLoggedIn: false
};

const accountReducer = (state = initialState, action: AccountReducerActionProps) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload!;
            return {
                ...state,
                user,
                isBackendLoggedIn: true,
                isCognitoLoggedIn: true
            };
        }
        case LOGIN: {
            // const { user } = action.payload!;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                isCognitoLoggedIn: true,
                isBackendLoggedIn: true
                // user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                backendUser: false,
                isCognitoLoggedIn: false,
                isBackendLoggedIn: false,
                user: null
            };
        }
        case LOGIN_COGNITO: {
            return {
                ...state,
                isCognitoLoggedIn: true,
                isInitialized: true
            };
        }
        case SAVE_COGNITO_USER: {
            const { user } = action.payload!;
            return {
                ...state,
                isInitialized: true,
                isCognitoLoggedIn: true,
                isLoggedIn: false,
                user
            };
        }
        case SET_ASSOCIATE_SOFTWARE_TOKEN: {
            const { associateSoftwareToken, isCognitoLoggedIn } = action.payload!;
            return {
                ...state,
                isCognitoLoggedIn,
                associateSoftwareToken
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
